import React from 'react'
import { ActivityLogEntries } from '@trustero/trustero-api-web/lib/activity/activity_pb'
import { EmptyChangelog } from './Changelog.styles'

export const CHANGELOG_PAGE_SIZE = 10

export interface ChangeLogEntriesProps {
  entries: ActivityLogEntries
}

export const EmptyLog = ({ content }: { content: string }): JSX.Element => {
  return <EmptyChangelog>{content}</EmptyChangelog>
}
